import { Box } from '@material-ui/core'
import PropTypes from 'prop-types'
import { CATEGORY_LABEL, CODE_LABEL, PRODUCT_LABEL } from '../../../utils/constants'
import BaseTable from '../BaseTable'
import ButtonTable from '../ButtonTable'

CategoryTable.propTypes = {
  products: PropTypes.array,
  onClick: PropTypes.func.isRequired,
}

export default function CategoryTable({ products, onClick }) {
  const headCells = [
    { id: 'category', label: CATEGORY_LABEL },
    { id: 'code', label: CODE_LABEL },
    { id: 'name', label: PRODUCT_LABEL },
    { id: 'update', label: '' },
    { id: 'delete', label: '' },
  ]

  const buttonsDetails = [
    { title: 'AJOUTER UNE CATÉGORIE', name: 'addCategory' },
    { title: 'AJOUTER UNE MARQUE', name: 'addBrand' },
  ]
  return (
    <Box>
      <ButtonTable buttonsDetails={buttonsDetails} title="GESTION DES CATÉGORIES" onClick={onClick} />
      <BaseTable defaultOrderBy="name" hasPadding headCells={headCells} tableData={products} />
    </Box>
  )
}
